module.exports = __webpack_public_path__ + "img/IMAGE13.36814679.jpg";